var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MyProjectsSection,{staticClass:"invoices-outgoing",attrs:{"icon":"contractoutgoing","title":_setup.t('invoices.outgoing-invoices_USERTYPE'),"help-text":_setup.t('invoices.helptexts.outgoing_USERTYPE')}},[_c(_setup.InvoicesTable,{attrs:{"data":_setup.outgoingInvoices,"type":"outgoing"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }